// extracted by mini-css-extract-plugin
export default {"link":"qS-z","disabled":"rS-z"};